module.exports = __webpack_public_path__ + "static/img/banner_recruit_03.043bee9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/join/banner_recruit_03.png
// module id = BvHn
// module chunks = 10